import { render, staticRenderFns } from "./Skids.vue?vue&type=template&id=73df2a2c"
import script from "./Skids.vue?vue&type=script&lang=js"
export * from "./Skids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports